export default __webpack_public_path__ + "static/media/banners_8.1463394b.png";